import { render, staticRenderFns } from "./NewResetPassword.vue?vue&type=template&id=72a9f746&scoped=true"
import script from "./NewResetPassword.vue?vue&type=script&lang=js"
export * from "./NewResetPassword.vue?vue&type=script&lang=js"
import style0 from "./NewResetPassword.vue?vue&type=style&index=0&id=72a9f746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9f746",
  null
  
)

export default component.exports